<!-- payment-report-view.component.html -->
<div class="container-fluid">
    <!-- Page Header with Utility Buttons -->
    <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
        <h1 class="page-header mb-2 mb-lg-0">Payment List</h1>

        <!-- Utility Buttons -->
        <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
            <!-- Button Group -->
            <div class="d-flex flex-wrap gap-1">
                <button *ngIf="_permissionsService.canAccess('payments_collect')"
                    color="primary"
                    mat-flat-button
                    class="me-1 mb-1"
                    (click)="openEntityComponentPayment(PaymentsEntityComponent, 'payments', 'payment', 'create')">
                    Add Payment
                </button>
                <button *ngIf="_permissionsService.canAccess('reports_export')"
                    color="primary"
                    mat-flat-button
                    class="me-1 mb-1"
                    [disabled]="isLoading"
                    (click)="downloadPaymentReport()">
                    <mat-icon *ngIf="isLoading" class="mat-icon-animate-spin">autorenew</mat-icon>
                    <ng-container *ngIf="!isLoading">
                      <mat-icon>file_download</mat-icon>
                      <span>Export</span>
                    </ng-container>
                    <span *ngIf="isLoading">Exporting...</span>
                </button>
                <button *ngIf="_permissionsService.canAccess('reports_export')"
                    style="background-color: transparent !important; border: none;"
                    (click)="printPaymentReport()"
                    type="button"
                    mat-icon-button
                    class="me-1 mb-1"
                    matTooltip="Print payments report"
                    matTooltipPosition="below"
                    aria-label="Print payments report">
                    <mat-icon style="color: #1C3F8B;">print</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Filter
            </mat-panel-title>
            <mat-panel-description>
                <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
            <div class="row">
                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field class="full-width-field">
                        <mat-label>Payment ID</mat-label>
                        <input name="field_payment_id_value" (input)="onSubmit(f)" matInput ngModel>
                    </mat-form-field>
                </div>

                <!-- Check Number Filter -->
                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field class="full-width-field">
                        <mat-label>Check Number</mat-label>
                        <input name="field_check_number_value" matInput ngModel
                            (input)="onSubmit(f)">
                    </mat-form-field>
                </div>

                <!-- Customer Name Autocomplete -->
                <!-- <div class="col-2">
                    <mat-form-field class="full-width-field">
                        <mat-label>Customer Name</mat-label>
                        <input name="field_customer_name_value" (input)="onViewsAutocompleteCustomerName($event)" matInput
                            ngModel [matAutocomplete]="autoCompleteCustomerName">
                        <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
                            <mat-icon>manage_accounts</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-autocomplete #autoCompleteCustomerName="matAutocomplete" (optionSelected)="onSubmit(f)">
                        <mat-option *ngFor="let option of autocompleteCustomerNameOptions" [value]="option.label">
                            {{option.label}} ({{option.value}})
                        </mat-option>
                    </mat-autocomplete>
                </div> -->

                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field class="full-width-field">
                        <mat-label>Date Range</mat-label>
                        <input #dateRangeInput matInput
                            [value]="dateRangeDisplayValue"
                            placeholder="Select date range"
                            readonly
                            name="dateRange">
                        <button matSuffix mat-icon-button type="button" (click)="openDateRangePicker()">
                            <mat-icon>calendar_today</mat-icon>
                        </button>
                    </mat-form-field>
                </div>


                <!-- <div class="col-2">
                    <mat-form-field class="full-width-field">
                        <mat-label>Status</mat-label>
                        <mat-select matInput ngModel name="field_status_value" (blur)="onSubmit(f)"
                            (selectionChange)="onSubmit(f)">
                            <mat-option value="All" selected="selected">- Any -</mat-option>
                            <mat-option value="Paid">Paid</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div> -->

                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field class="full-width-field">
                        <mat-label>Student</mat-label>
                        <input #studentInput name="title_1" (input)="onAutocompleteStudent($event)" matInput ngModel
                            [matAutocomplete]="autoCompleteStudent">
                        <button (click)="redirectUserProfile(studentInput)" type="button" matSuffix mat-icon-button aria-label="manage_accounts">
                            <mat-icon>manage_accounts</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-autocomplete #autoCompleteStudent="matAutocomplete" (optionSelected)="onSubmit(f)">
                        <mat-option *ngFor="let option of autoCompleteStudentOptions" [value]="option.label">
                            {{option.label}} ({{option.value}})
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field class="full-width-field">
                        <mat-label>Package</mat-label>
                        <input #packageInput name="field_enrollment_package_name_target_id" (input)="onAutocompletePackage($event)" matInput ngModel
                            [matAutocomplete]="autoCompletePackage">
                        <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
                            <mat-icon>manage_accounts</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-autocomplete #autoCompletePackage="matAutocomplete" (optionSelected)="onSubmit(f)">
                        <mat-option *ngFor="let option of autoCompletePackageOptions" [value]="option.label">
                            {{option.label}} ({{option.value}})
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <section class="section">

                    <div class="float-end bring-inline">
                        <button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear
                            <!-- <mat-icon (click)="resetForm()" aria-hidden="false" aria-label="Menu dropdown" class=""></mat-icon> -->
                        </button>
                    </div>

                </section>
            </div>

            <section class="section">
            </section>

        </form>

    </mat-expansion-panel>

    <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

    <!-- <mat-form-field appearance="standard">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="" #input>
    </mat-form-field> -->

    <!-- <div class="example-container mat-elevation-z8">
    <div class="loading-shade"
    *ngIf="ShowProgressBar">
    <mat-spinner *ngIf="ShowProgressBar"></mat-spinner>
    <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
        No limit
    </div>
    </div>
    </div> -->

    <div class="table-responsive-sticky table-responsive">

        <table mat-table #displayTable [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

            <!-- field_student_name Column -->
            <ng-container matColumnDef="field_student_name">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Student Name">
                    Student Name
                </th>
                <td mat-cell *matCellDef="let element"> <a class="cursor-pointer"
                    (click)="openDialog(StudentDashboardWrapperComponent, 'largerScreenDashboard', {
                        student_id: element?.student_account_contacts_from_payment_field.split(', ')[0]
                    })">{{ element.field_student_name }}</a> </td>

            </ng-container>

            <!-- field_payment_id Column -->
            <ng-container matColumnDef="field_payment_id">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Payment ID">
                    Payment ID
                </th>
                <td mat-cell *matCellDef="let element"> {{element.field_payment_id}}
                </td>
            </ng-container>

            <!-- field_customer_name Column -->
            <!-- <ng-container matColumnDef="field_customer_name">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Customer Name">
                    Customer Name
                </th>
                <td mat-cell *matCellDef="let element"> {{
                    element.field_customer_name
                    }} </td>
            </ng-container> -->

            <!-- field_date_and_time Column -->
            <ng-container matColumnDef="field_date_and_time">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Date">
                    Date
                </th>
                <td mat-cell *matCellDef="let element"> {{ reportDateService.formatDate(element.field_date_and_time) }} </td>
            </ng-container>

            <!-- field_gross_tuition Column -->
            <ng-container matColumnDef="field_gross_tuition">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Payment Amount" class="text-end">
                    Enrollment Amount Paid
                </th>
                <td mat-cell *matCellDef="let element" class="text-end"> {{ element.field_gross_tuition | studioCurrency }}
                </td>
            </ng-container>

            <!-- field_tax_amount Column -->
            <ng-container matColumnDef="field_tax_collected">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Tax" class="text-end">
                Tax Amount
                </th>
                <td mat-cell *matCellDef="let element" class="text-end">{{ (element.field_tax_collected ? element.field_tax_collected : "0") | studioCurrency }}</td>
            </ng-container>

            <!-- field_enrollment_name Column -->
            <ng-container matColumnDef="field_enrollment_name">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Enrollment Name">
                    Enrollment Name
                </th>
                <td mat-cell *matCellDef="let element"> {{
                    element.field_enrollment_name }} </td>
            </ng-container>

            <!-- field_payment_type Column -->
            <ng-container matColumnDef="field_payment_type">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Payment Type">
                    Payment Type
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.field_payment_type }}
                    <i [ngClass]="getPaymentIcon(element?.ccProcessorType)" aria-hidden="true"></i>
                    <span *ngIf="element.field_payment_type === 'Square Terminal' || element.field_payment_type === 'PayBright Terminal'"
                          [ngClass]="element.field_status === 'Paid' || element.field_status === 'Completed' ? 'btn btn-sm badge amt-bg-green status-badge' : 'btn btn-sm badge amt-bg-red status-badge'"
                          class="mat-badge ms-2 px-2 py-1 rounded-pill">
                        {{ element.field_status }}
                    </span>
                </td>
            </ng-container>

            <!-- field_status Column -->
            <ng-container matColumnDef="field_status">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Status">
                    Status
                </th>
                <td mat-cell *matCellDef="let element"> {{
                    element.field_status }} </td>
            </ng-container>

            <!-- nothing Column -->
            <!-- <ng-container matColumnDef="nothing">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Assign">
                    Assign
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.nothing
                    }}
                </td>
            </ng-container> -->

            <!-- field_teacher Column -->
            <ng-container matColumnDef="field_teacher">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Teacher">
                    Teacher
                </th>
                <td mat-cell *matCellDef="let element"> {{ element.AllScheduledPaymentInstructors }} </td>
            </ng-container>

            <!-- edit Column -->
            <!-- <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Edit">
                    Edit
                </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-stroked-button
                        (click)="openEntityComponent(PaymentsEntityComponent, 'payments', 'payment', 'edit', element.id)"
                        mat-button>
                        Edit
                    </button>
                </td>
            </ng-container> -->

            <!-- field_notes Column -->
            <ng-container matColumnDef="field_notes">
                <th mat-header-cell *matHeaderCellDef>Notes</th>
                <td mat-cell *matCellDef="let element">
                <mat-icon
                    *ngIf="element.field_notes"
                    [matTooltip]="element.field_notes | htmlDecode"
                    matTooltipPosition="above"
                >notes</mat-icon>
                </td>
            </ng-container>

            <!-- edit Column -->
            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by edit">
                    Actions
                </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button [matMenuTriggerFor]="paymentMenu" [matMenuTriggerData]="{paymentID: element.id}">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                </td>
            </ng-container>

            <!-- Footer for pagination -->
            <ng-container matColumnDef="pagination-footer">
                <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
                    <div class="d-flex align-items-center">
                        <button mat-icon-button
                                type="button"
                                (click)="refreshData()"
                                [disabled]="ShowProgressBar"
                                matTooltip="Refresh"
                                matTooltipPosition="above"
                                aria-label="Refresh">
                            <mat-icon>refresh</mat-icon>
                        </button>
                        <mat-paginator class="flex-grow-1 bg-transparent" (page)="pageChanged($event)" [pageSizeOptions]="onPageSizeOptions()" [length]="30"
                            [disabled]="ShowProgressBar"
                            [pageSize]="paginationTotalPages" [pageIndex]="paginationIndex" aria-label="Select page of view">
                        </mat-paginator>
                    </div>
                </td>
            </ng-container>

            <mat-menu #paymentMenu="matMenu">
                <ng-template matMenuContent let-paymentID="paymentID" let-payment="element">
                    <!-- <button mat-menu-item
                        (click)="openEntityComponent(PaymentsEntityComponent, 'payments', 'payment', '0', paymentID)"
                        >
                        View
                    </button> -->
                    <button mat-menu-item
                        (click)="openReceiptDialog(paymentID)"
                        >
                        View Receipt
                    </button>
                    <button *ngIf="_permissionsService.canAccess('payments_collect')" mat-menu-item
                        (click)="openEntityComponent(PaymentsEntityComponent, 'payments', 'payment', 'edit', paymentID)"
                        >
                        Edit
                    </button>
                    <button *ngIf="_permissionsService.canAccess('payments_delete')" mat-menu-item
                        (click)="openEntityComponent(PaymentsEntityComponent, 'payments', 'payment', 'delete', paymentID)"
                        >
                        Delete
                    </button>
                    <button *ngIf="_permissionsService.canAccess('payments_refund')" mat-menu-item
                        (click)="openEntityComponent(PaymentsEntityComponent, 'payments', 'payment', 'refund', paymentID)"
                        >
                        Refund
                    </button>
                </ng-template>
            </mat-menu>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"
                [class.amt-row-unpaid]="row.field_status && row.field_status !== 'Paid' && row.field_status !== 'Completed'"></tr>
            <tr mat-footer-row *matFooterRowDef="['pagination-footer']; sticky: true"></tr>
        </table>

        <ng-container *ngIf="!this.dataSource">
            <div>
            This student has no payments.
            </div>
        </ng-container>

    </div>
</div>
